import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-adjust-icon',
  templateUrl: './design-adjust.component.html'
})
export class DesignAdjustComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
